import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDefined } from "class-validator";

import { DateRange } from "./DateRange";
import { NumberRange } from "./NumberRange";
import { SeasonDay } from "./SeasonDay";

// whitelist beats blacklist

@Exclude()
export class Season {
  @IsDefined()
  @Expose()
  @Type(() => DateRange)
  public dateRange: DateRange;

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => SeasonDay)
  public days: SeasonDay[] = new Array<SeasonDay>();

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => NumberRange)
  public hoursWhitelist: NumberRange[] = new Array<NumberRange>();

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => NumberRange)
  public hoursBlacklist: NumberRange[] = new Array<NumberRange>();

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => Date)
  public dateBlacklist: Date[] = new Array<Date>(); // ignores year

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => Date)
  public dateWhitelist: Date[] = new Array<Date>(); // ignores year
}
